import urlConstants from '~/lib/constants/url.constants';

import api from './api';
import { CacheTag } from './CacheTag';

interface AddOutOfOfficeRequest {
  providerExternalId: string;
  endDate?: string;
  startDate?: string;
}

interface EditOutOfOfficeRequest {
  startDate?: string;
  endDate?: string;
  providerExternalId: string;
  outOfOfficeId: string;
}

interface DeleteOutOfOfficeRequest {
  providerExternalId: string;
  outOfOfficeId: string;
}

export const profileApi = api.injectEndpoints({
  endpoints: (build) => ({
    addOutOfOffice: build.mutation<void, AddOutOfOfficeRequest>({
      invalidatesTags: [CacheTag.ProfileOutOfOffice],
      query: ({ providerExternalId, startDate, endDate }) => ({
        body: {
          endDate,
          startDate,
        },
        method: 'POST',
        url: urlConstants.user_profile.addOutOfOffice(providerExternalId),
      }),
    }),
    deleteOutOfOffice: build.mutation<void, DeleteOutOfOfficeRequest>({
      invalidatesTags: [CacheTag.ProfileOutOfOffice],
      query: ({ outOfOfficeId, providerExternalId }) => ({
        headers: {
          'content-type': 'application/json',
        },
        method: 'DELETE',
        responseHandler: 'text',
        url: urlConstants.user_profile.deleteOutOfOffice(
          providerExternalId,
          outOfOfficeId,
        ),
      }),
    }),
    editOutOfOffice: build.mutation<void, EditOutOfOfficeRequest>({
      invalidatesTags: [CacheTag.ProfileOutOfOffice],
      query: ({ providerExternalId, outOfOfficeId, startDate, endDate }) => ({
        body: {
          endDate,
          startDate,
        },
        method: 'PUT',
        url: urlConstants.user_profile.editOutOfOffice(
          providerExternalId,
          outOfOfficeId,
        ),
      }),
    }),
    getAllOutOfOfficeList: build.query<
      OutOfOfficeItem[],
      { providerExternalId: string; startDate: string }
    >({
      providesTags: [CacheTag.ProfileOutOfOffice],
      query: ({ providerExternalId, startDate }) =>
        urlConstants.user_profile.getOutOfOfficeList(
          providerExternalId,
          startDate,
        ),
    }),
  }),
});

export const {
  useGetAllOutOfOfficeListQuery,
  useAddOutOfOfficeMutation,
  useDeleteOutOfOfficeMutation,
  useEditOutOfOfficeMutation,
} = profileApi;
